import { UseQueryOptions } from '@tanstack/react-query';
import { getUserProfilePath, UserConfig } from 'ihub/common';
import { CRUDHelperBase } from '../classes/crud-helper-base';
import {
	buildURL,
	getTenantID,
	standardGet,
	validateOkResponse,
} from '../classes/http-helper-const';
import { cacheStaleTime } from '../constants';

export class UserHttpService extends CRUDHelperBase<UserConfig> {
	constructor() {
		super(UserConfig.name);
	}

	getUserProfile(): UseQueryOptions<UserConfig, Error, UserConfig> {
		return {
			queryKey: [getTenantID(), this.objectType, getUserProfilePath],
			queryFn: async (): Promise<UserConfig> => {
				const url = buildURL(this.objectType, [getUserProfilePath]);
				const res = await standardGet(url);
				await validateOkResponse(res, 'get user profile', this.objectType);
				return await res.clone().json();
			},
			staleTime: cacheStaleTime,
		};
	}
}
